import { styles } from '@app/services/app-styles.service';

const breadcrumb = {
    root: {
        background: 'transparent',
        padding: '0 0 ' + styles().marginPage + ' 0',
    },
};

export default breadcrumb;
